import { Col, Container, Row, Stack } from "react-bootstrap"

const HireQADeveloperContent = () => {
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>Hire QA Engineers to Ensure Quality, Reliability & Seamless User Experience</h2>
                        <p>
                            Deliver flawless software with our experienced QA engineers. From functional testing to automation, we ensure your applications meet the highest standards in performance, security, and usability — across devices and platforms.
                        </p>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Why Hire QA Engineers from Us?</h2>
                        <ul>
                            <li>
                                <b>End-to-End Testing Expertise</b>
                                <p>
                                    We cover functional, regression, performance, usability, security, and cross-browser testing — ensuring comprehensive test coverage.
                                </p>
                            </li>
                            <li>
                                <b>Manual & Automated Testing</b>
                                <p>
                                    Our QA experts use industry-leading tools like Selenium, Cypress, Postman, and JMeter to deliver faster and more reliable results.
                                </p>
                            </li>
                            <li>
                                <b>Agile & DevOps-Ready QA</b>
                                <p>
                                    Integrated seamlessly with your Agile or CI/CD pipeline to enable continuous testing and early bug detection.
                                </p>
                            </li>
                            <li>
                                <b>Platform & Device Coverage</b>
                                <p>
                                    We ensure your application works smoothly across mobile, desktop, and web environments — including Android, iOS, and all major browsers.
                                </p>
                            </li>
                            <li>
                                <b>Bug Reporting & Test Documentation</b>
                                <p>
                                    Receive clear, actionable reports and well-documented test cases to support fast fixes and future maintenance.
                                </p>
                            </li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Our QA & Testing Services</h2>
                        <ul>
                            <li>Manual Testing</li>
                            <li>Automation Testing (Selenium, Cypress)</li>
                            <li>API Testing (Postman, Swagger)</li>
                            <li>Performance & Load Testing (JMeter, BlazeMeter)</li>
                            <li>Mobile & Web Application Testing</li>
                            <li>Cross-Browser & Cross-Device Testing</li>
                        </ul>
                    </Stack>

                    <Stack className="hire-content-info">
                        <h2>Ensure Quality from Day One</h2>
                        <p>
                            Avoid costly bugs and poor user experience. Hire our QA professionals to test smarter, release faster, and deliver top-notch software. Get in touch with us for flexible hiring models and pricing.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireQADeveloperContent;
